import React from "react";
import "./style.css";

const EngagementModelTable = ({ content }) => {

    return (
        <div className="engagement-model-table-box">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="engagement-model-table-box-comparison">
                            <h2 className="low-top-heading">{content.sectionHeading}</h2>
                            <p className="engagement-model-table-box-heading mb-0">
                                {content.subHeading}
                            </p>
                            <p className="description-text mb-4">{content.description}</p>

                            <div className="engagement-model-table-box-wrapper">
                                <table className="engagement-model-table-box-table">
                                    <thead>
                                        <tr>
                                            {content.tableHead.map((head, index) => (
                                                <th key={index}>{head}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {content.tableData.map((item, index) => (
                                            <tr key={index}>
                                                {item.textOne && <td dangerouslySetInnerHTML={{ __html: item.textOne }}></td>}
                                                {item.textTwo && <td dangerouslySetInnerHTML={{ __html: item.textTwo }}></td>}
                                                {item.textThree && <td dangerouslySetInnerHTML={{ __html: item.textThree }}></td>}
                                                {item.textFour && <td dangerouslySetInnerHTML={{ __html: item.textFour }}></td>}
                                                {item.textFive && <td dangerouslySetInnerHTML={{ __html: item.textFive }}></td>}
                                                {item.textSix && <td dangerouslySetInnerHTML={{ __html: item.textSix }}></td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {content.noteText && <p className="engagement-models-no-refund-text">
                            <strong>Note:</strong> {content.noteText}
                        </p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EngagementModelTable;